export default __webpack_public_path__ + "static/media/alertCircleGreen.6c1c49df.svg";